import React, { useEffect } from 'react';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import ClientEmailAddresses from 'Components/UI/ClientEmailAddresses';
import useCollection from 'Hooks/useCollection';
import useHouseholdResource from 'Hooks/useHouseholdResource';
import EmailIcon from '@material-ui/icons/Email';
import RoundButton from 'Components/UI/RoundButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import HouseholdSectionPicker from 'Components/Flyouts/HouseholdInfo/Sections/Section/HouseholdSectionPicker/HouseholdSectionPicker';

const useStyles = makeStyles(theme => ({
  subHeader: {
    marginBottom: theme.spacing(1.5),
  },
  emailCollection: {
    display: 'flex',
    flexDirection: 'column',
  },
  emailAll: {
    borderRadius: '50px',
  },
}));

const EmailSection = () => {
  const classes = useStyles();
  useEffect(() => {}, []);
  const householdContext = useSimpleHousehold();
  const { householdResource } = householdContext;
  const { resource } = useHouseholdResource(householdResource);
  const {
    collection: clientCollection,
    setCollection: setClientCollection,
  } = useCollection();
  const {
    collection: emailAddressesCollection,
    setCollection: setEmailAddressesCollection,
  } = useCollection();

  useEffect(() => {
    resource
      .relationship('clients')
      .link('related')
      .Get()
      .then(setClientCollection)
      .catch((err) => {
        displayErrorMessage(err, err.errors);
      });

    resource
      .relationship('emailAddresses')
      .link('related')
      .Get()
      .then(setEmailAddressesCollection)
      .catch((err) => {
        displayErrorMessage(err, err.errors);
      });
  }, [householdResource]);

  const refreshHouseholdEmailAddresses = () => resource
    .relationship('emailAddresses')
    .link('related')
    .Get()
    .then(setEmailAddressesCollection)
    .catch((err) => {
      displayErrorMessage(err, err.errors);
    });

  const emailAllHouseholdEmailAddresses = () => {
    const activeHouseholdEmailAddresses = emailAddressesCollection
      .resources()
      .list()
      .filter(emailAddress => emailAddress.attr('isActive') === 'true');
    const emailAddressString = activeHouseholdEmailAddresses
      .map(householdEmailAddress => householdEmailAddress.attr('address'))
      .join(';');
    const url = `https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${encodeURIComponent(
      emailAddressString,
    )}&tf=1`;
    window.open(url, '_blank');
  };

  const emailAll = () => {
    if (emailAddressesCollection.length === 0) {
      refreshHouseholdEmailAddresses().then(emailAllHouseholdEmailAddresses);
    } else {
      emailAllHouseholdEmailAddresses();
    }
  };

  const onUpdate = () => refreshHouseholdEmailAddresses();

  if (!clientCollection) {
    return null;
  }

  return (
    <HouseholdSectionPicker label="Email" resource={householdResource}>
      <div>
        <RoundButton
          onClick={emailAll}
          size="small"
          className={classes.emailAll}
          variant="contained"
          color="primary"
          startIcon={<EmailIcon />}
        >
          Email All
        </RoundButton>
      </div>
      {clientCollection
        .resources()
        .list()
        .map(client => (
          <div className="section-row" key={`emailAddress-${client.id()}`}>
            <div>
              <Typography className={classes.subHeader}>
                {client.attr('firstName')} {client.attr('lastName')}
              </Typography>
              <div>
                <ClientEmailAddresses
                  onUpdate={onUpdate}
                  clientResource={client}
                />
              </div>
            </div>
          </div>
        ))}
    </HouseholdSectionPicker>
  );
};

EmailSection.propTypes = {};

EmailSection.defaultProps = {};

export default EmailSection;
